module.exports = __webpack_public_path__ + "img/snorkeling-16.f746a10b.jpeg";